import styles from './category-department.module.scss'
import { Button, PageContainer, PageHeader } from "@touche-lts/panel-ui/dist"
import { IconUserManagement } from 'assets/icons'
import { useRootStore } from "mobx-stores/store-provider"
import { useEffect } from "react"
import { useParams } from "react-router"
import { CategoryHierarhyLevelsPage } from "./hierarhy-levels"
import { GalleryCategoryDepartmentsPage } from "./image-category-gallery"
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { useGetIsResponsiveScreen } from 'hooks/custom-hooks'

const CategoryDepartmentPageComponent = (props) => {
  const {
    className,
    style,
    history: { push }
  } = props,
    {
      departmentsStore: {
        addCategoryDepartment,
        resetCategoryStore,
        setStoreCategory,
        departmentStore,
        departmentCategory
      }
    } = useRootStore(),

    { departmentId, categoryId } = useParams<{ departmentId: string, categoryId: string }>();


  useEffect(() => {
   
    const subCategoryEdit = JSON.parse(localStorage.getItem('subCategoryEdit'));
    if (subCategoryEdit) {
      setStoreCategory(subCategoryEdit);
    }
    
  }, [resetCategoryStore, setStoreCategory])

  const {isResponsive:isLaptop} = useGetIsResponsiveScreen('(max-width: 1024px)')
  return (
    <PageContainer className={cl(className, styles.scrollable)} style={style}>
      <PageHeader
        navSegments={[
          {
            icon: IconUserManagement,
            label: 'Departments',
            iconProps: { viewBox: '0 0 22 22' },
            onClick: () => push('/departments')
          },
          {
            label: departmentStore?.name,
            onClick: () => push('/departments/' + departmentId)
          },
          {
            label: categoryId === 'category' ? 'Add new category' : `Edit Category`
          }
        ]}
          middleContainerChildren={
          isLaptop && 
          <>
            <div className={styles.middleContainerStyle} style={{flexDirection:'column'}}>
              <Button preset='secondary' onClick={() => push('/departments/' + departmentId)}>
                Discard Changes
              </Button>
              <Button preset='primary' children={categoryId === 'category' ? 'Add new Category' : 'Update Category'} onClick={() => addCategoryDepartment(departmentId)} />
            </div>
          </>
        }
        buttons={!isLaptop ? [
          {
            preset: 'secondary',
            children: 'Discard Changes',
            onClick: () => push('/departments/' + departmentId)
          },
          {
            preset: 'primary',
            children: categoryId === 'category' ? 'Add new Category' : 'Update Category',
            onClick: () => addCategoryDepartment(departmentId)
          }
        ] : []}
      />
      <GalleryCategoryDepartmentsPage />
      <div className='pt-4'>
        <CategoryHierarhyLevelsPage />
      </div>
    </PageContainer>
  )
},

  CategoryDepartmentsPage = observer(CategoryDepartmentPageComponent)
export { CategoryDepartmentsPage }